import React, { useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  HStack,
  Text,
  VStack,
  useTheme,
  Box,
} from "@chakra-ui/react";
import { MdOutlineAssignment } from "react-icons/md";

const TimeTableFileModal = ({ isOpen, onClose, files }) => {
  const theme = useTheme();
  const { fileBorderColor } = theme.colors.pallete;
  const [selectedFile, setSelectedFile] = useState(null);

  const handleFileClick = async (file) => {
    setSelectedFile(file);
  };

  const handleOnClose = () => {
    setSelectedFile(null);
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleOnClose}
      size={selectedFile ? "xl" : "md"}
    >
      <ModalOverlay />
      <ModalContent maxH="80vh">
        <ModalHeader textAlign="center" fontSize="18px">
          Files
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody mb={5}>
          {selectedFile ? (
            <VStack spacing={4} align="stretch" h="full">
              <HStack justify="space-between">
                <Text fontSize="14px" fontWeight={600}>
                  {selectedFile?.name || selectedFile?.fileName}
                </Text>
                <Text
                  fontSize="12px"
                  color="blue.500"
                  cursor="pointer"
                  onClick={() => {
                    setSelectedFile(null);
                  }}
                >
                  Back to files
                </Text>
              </HStack>
              <Box h="60vh" overflow="hidden">
                <iframe
                  src={selectedFile?.url}
                  width="100%"
                  height="100%"
                  title={selectedFile?.name || selectedFile?.fileName}
                  style={{ border: "none" }}
                />
              </Box>
            </VStack>
          ) : (
            <VStack spacing={4} align="stretch">
              {files && files.length > 0 ? (
                files.map((file, index) => (
                  <HStack
                    key={index}
                    px="6px"
                    py="10px"
                    h="34px"
                    borderRadius="4px"
                    borderWidth="1px"
                    borderColor={fileBorderColor}
                    justify="space-between"
                    onClick={() => handleFileClick(file)}
                    cursor="pointer"
                    _hover={{ bg: "gray.50" }}
                  >
                    <HStack spacing={2}>
                      <MdOutlineAssignment size={20} />
                      <Text fontSize="12px" fontWeight={500} noOfLines={1}>
                        {file.name || file.fileName}
                      </Text>
                    </HStack>
                  </HStack>
                ))
              ) : (
                <Text>No files available</Text>
              )}
            </VStack>
          )}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default TimeTableFileModal;
